/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updaterequiredbtnupdate3Inputs */



/**
* | output |
* | --- |
* | "Update" |
*
* @param {Updaterequiredbtnupdate3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const updaterequiredbtnupdate3 = /** @type {((inputs?: Updaterequiredbtnupdate3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updaterequiredbtnupdate3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Update")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar")
	return /** @type {LocalizedString} */ ("Обновить")
});
export { updaterequiredbtnupdate3 as "updateRequiredBtnUpdate" }